import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-brand-700 text-white",
        secondary:
          "border-transparent bg-surface-secondary text-gray-700",
        destructive:
          "border-transparent bg-status-error text-white",
        outline: "text-gray-700 border-surface-border",
        success:
          "border-transparent bg-status-success text-white",
        warning:
          "border-transparent bg-status-warning text-gray-900",
        info:
          "border-transparent bg-status-info text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }

